import React from 'react';

const TabRow = ({ items, activeItem, ...otherProps }) => {
    const foundItem = items.find(i => i != null && i.id === activeItem);
    return (
        <div className="side-bar-tabrow" {...otherProps}>
            {items.map(i => {
                if (i == null) return;
                return (
                    <div key={i.id} className={`side-bar-tabrow-tab${i.id === activeItem ? ' side-bar-tabrow-active' : ''}`} onClick={() => i.onClick(i.id)}>
                        <div className="side-bar-tabrow-tab-title">{i.title}</div>
                        <div className="side-bar-tabrow-tab-icon">
                            <img draggable="false" style={i.iconStyle} alt={i.title} src={i.icon} />
                        </div>
                    </div>
                );
            })}
            <div className="side-bar-tabrow-content">{foundItem && foundItem.component}</div>
        </div>
    );
};

export default TabRow;
